
import {
  computed,
  defineComponent,
  ref,
} from 'vue';
import { useStore } from '@/store';
import 'vue3-carousel/dist/carousel.css';
import {
  Carousel,
  Slide,
  Navigation,
} from 'vue3-carousel';
import useWindowSize from '@/composables/useWindowSize';

export default defineComponent({
  name: 'PhotoCarouselContent',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  setup() {
    const store = useStore();
    const photos = computed(() => store.state.photosInCarousel);
    const currentSlide = ref(0);

    const { windowWidth, windowHeight } = useWindowSize();

    return {
      photos,
      currentSlide,
      windowWidth,
      windowHeight,
    };
  },
});
